import { Component, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BorrowerValue } from '@app/app/interfaces/borrower-value.model';

@Component({
  selector: 'app-business-values',
  templateUrl: 'business-values.component.html',
  styleUrls: ['business-values.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DatePipe,
    MatTooltipModule,
  ],
})
export class BusinessValuesComponent {

  @Input() values: Partial<BorrowerValue>[];
}
